export default __webpack_public_path__ + "images/88b0c5e0387c3c7510a91e8e49428ebc.png";